import ModelBuilderMainPage from "../../Components/EditModelbuilder/ModelBuilderMainPage";

const ModelBuilder = () => {
  return <ModelBuilderMainPage />;
};

export default ModelBuilder;
